import React from "react";

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    if (!validateInput(message)) {
      return;
    }

    actions.handleBotResponse(message);
  };

  /**
   * Validates user input to prevent empty messages or malicious inputs
   */
  const validateInput = (message) => {
    if (!message || typeof message !== "string") return false;

    const trimmedMessage = message.trim();
    if (trimmedMessage.length === 0) return false;

    const blockedPatterns = [
      /^<script>/i,
      /select .* from/i,
      /drop table/i,
      /union select/i,
      /--/,
    ]; // Prevent SQL/XSS attacks
    return !blockedPatterns.some((pattern) => pattern.test(trimmedMessage));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;
